define([
    "dojo/_base/declare",
    "dojo/dom-geometry",
    "MW/layout/LayoutChildProperty",
    "MW/layout/Traversable"
], function (declare, domGeometry, LayoutChildProperty, Traversable) {
    return declare([Traversable], {
        /**
         * This class defines an interface to be implemented by all classes that support "panels" as children.
         * Among other things these containers are expected to support dragging panels from one container to another.
         * Both SideContainer and BottomContainer are expected to implement this interface
         */

        addPanel: function (widget, properties) {},

        removePanel: function (widget, properties) {},

        getPanels: function () {
            return [];
        },

        getPanelProperties: function () {
            return [];
        },

        getPanelCount: function () {
            return 0;
        },

        isEmpty: function () {
            return this.getPanelCount() === 0;
        },

        isContainerCollapsed: function() {
            var parent = this.getParent();
            var region = this.region;
            return !!(parent && region && parent.isCollapsed(region));
        },

        isContainerCollapsing: function() {
            var parent = this.getParent();
            var region = this.region;
            return !!(parent && region && parent.isCollapsing(region));
        },

        isOrWasContainerCollapsed: function (dragOutInfo) {
            return this.isContainerCollapsed() || (this.region === dragOutInfo.region && dragOutInfo.wasCollapsed);
        },

        reCollapseContainer: function (dragOutInfo) {
            if (!this.isContainerCollapsed()) {
                var parent = this.getParent();
                var saveAnimation = parent.animationEnabled;
                parent.animationEnabled = false;
                parent.setFreeDimension(this.region, dragOutInfo.freeDimension);
                parent.collapse(this.region);
                parent.animationEnabled = saveAnimation;
            }
        },

        collapseChange: function (isCollapsed) {
            var that = this;
            if (!isCollapsed && this.collapsedWidget) {
                this.collapsedWidget.collapseAllChildrenImmediately();
            }
            if (isCollapsed && this._started) {
                // Get the pre-collapse free dimension from the containing border container
                // and store it in each child's properties for use as the initial on-top size.
                // The _started condition addresses geck 2021116 which occurred when a panel container was
                // minimized prior to UIContainer startup.
                var parent = this.getParent();
                var dimension = parent.getNonCollapsedFreeDimension(this.region);
                this.getPanelProperties().forEach(function (properties) {
                    if (that.region === "left" || that.region === "right") {
                        properties.__recentWidth = dimension;
                    } else {
                        properties.__recentHeight = dimension;
                    }
                });
            }
        },

        hideOnTopPanels: function () {
            if (this.isContainerCollapsed() && this._buttonBar) {
                this._buttonBar.collapseAllChildrenImmediately();
            }
        },

        destroyRecursive: function () {
            if (this._buttonBar) {
                this._buttonBar.destroyRecursive();
            }
            this.inherited(arguments);
        },

        /**
         * Returns the bounding box for a drag in operation in document coordinates.  This is simply the box
         * occupied by the container, unless the container is collapsed.  In the latter case the box occupied
         * by the corresponding panel bar is returned.
         */
        getDragInBox: function () {
            var box = domGeometry.position(this.isContainerCollapsed() ? this.collapsedWidget.domNode : this.domNode);
            box.l = box.x;
            box.t = box.y;
            return box;
        },

        dragIn: function (dragOutInfo, mousePoint) {}
    });
});
